import { API_URL } from "../../Config/config";
import { displayLog, fetchApiData, getLocalStorageItem } from "../../Helper/helper";
import { getInActiveBids } from "../../Services/bids.services";
import { SET_USER_PROFILE, SET_ROLE, SET_LOCATIONS, SET_LOADER, LOGOUT, SET_NOTIFICATIONS, SET_CHAT_HISTORY, SET_LOGIN, FETCH_PROFILE, SET_SELLER_ORDER_TAKING_STATUS, SET_BIDS_FOR_INACTIVE_SELLER } from "../actionTypes";

export const USER_ACTION_TYPES = {
	"GET_DASHBOARD_DETAILS": "GET_DASHBOARD_DETAILS",
	"GET_DASHBOARD_DETAILS_DONE": "GET_DASHBOARD_DETAILS_DONE",
	"GET_DASHBOARD_DETAILS_ERROR": "GET_DASHBOARD_DETAILS_ERROR",
	"GET_CREDITS_DATA": "GET_CREDITS_DATA",
	"GET_CREDITS_DATA_DONE": "GET_CREDITS_DATA_DONE",
	"GET_CREDITS_DATA_ERROR": "GET_CREDITS_DATA_ERROR",
	"SET_USER_PROFILE_PICTURE": "SET_USER_PROFILE_PICTURE",
	"SET_USER_PROFILE_PICTURE_DONE": "SET_USER_PROFILE_PICTURE_DONE",
	"SET_USER_PROFILE_PICTURE_ERROR": "SET_USER_PROFILE_PICTURE_ERROR",
	"SEND_EMAIL_VERIFICATION_OTP": "SEND_EMAIL_VERIFICATION_OTP",
	"SEND_EMAIL_VERIFICATION_OTP_DONE": "SEND_EMAIL_VERIFICATION_OTP_DONE",
	"SEND_EMAIL_VERIFICATION_OTP_ERROR": "SEND_EMAIL_VERIFICATION_OTP_ERROR",
	"ADD_UNVERIFIED_ACCOUNT_DATA_FROM_ACCESS_TOKEN": "ADD_UNVERIFIED_ACCOUNT_DATA_FROM_ACCESS_TOKEN",
	"ADD_UNVERIFIED_ACCOUNT_DATA_FROM_ACCESS_TOKEN_DONE": "ADD_UNVERIFIED_ACCOUNT_DATA_FROM_ACCESS_TOKEN_DONE",
	"ADD_UNVERIFIED_ACCOUNT_DATA_FROM_ACCESS_TOKEN_ERROR": "ADD_UNVERIFIED_ACCOUNT_DATA_FROM_ACCESS_TOKEN_ERROR",
};

export const setUserProfile = (payload) => {
	return {
		type: SET_USER_PROFILE,
		payload,
	};
};

export const setRole = (payload) => {
	return {
		type: SET_ROLE,
		payload,
	};
};

export const setLocations = (payload) => {
	return {
		type: SET_LOCATIONS,
		payload,
	};
};

export const setLoader = (payload) => {
	return {
		type: SET_LOADER,
		payload,
	};
};

export const resetUserState = (payload) => {
	return {
		type: LOGOUT,
		payload,
	};
};

export const setNotifications = (payload) => {
	return {
		type: SET_NOTIFICATIONS,
		payload,
	};
};

export const setChatHistory = (payload) => {
	return {
		type: SET_CHAT_HISTORY,
		payload,
	};
};

export const setLogin = (payload) => {
	return {
		type: SET_LOGIN,
		payload,
	};
};

export const getDashboardDetailsAction = (payload) => ({
	type: USER_ACTION_TYPES.GET_DASHBOARD_DETAILS,
	payload
});

export const getDashboardDetailsDoneAction = (payload) => ({
	type: USER_ACTION_TYPES.GET_DASHBOARD_DETAILS_DONE,
	payload
});

export const getDashboardDetailErrorsAction = (payload) => ({
	type: USER_ACTION_TYPES.GET_DASHBOARD_DETAILS_ERROR,
	payload
});

export const getCreditDetailsAction = (payload) => ({
	type: USER_ACTION_TYPES.GET_CREDITS_DATA,
	payload
});

export const getCreditsDetailsDoneAction = (payload) => ({
	type: USER_ACTION_TYPES.GET_CREDITS_DATA_DONE,
	payload
});

export const getCreditsDetailErrorsAction = (payload) => ({
	type: USER_ACTION_TYPES.GET_CREDITS_DATA_ERROR,
	payload
});

export const setSellerOrderTakingStatus = (payload) => {
	return {
		type: SET_SELLER_ORDER_TAKING_STATUS,
		payload,
	};
};
export const setBidsForInActiveSeller = (payload) => {
	return {
		type: SET_BIDS_FOR_INACTIVE_SELLER,
		payload,
	};
};
export const setUserProfileAction = (payload) => {
	return {
		type: USER_ACTION_TYPES.SET_USER_PROFILE_PICTURE,
		payload,
	};
}
export const setUserProfilePictureDoneAction = (payload) => {
	return {
		type: USER_ACTION_TYPES.SET_USER_PROFILE_PICTURE_DONE,
		payload,
	};
}
export const setUserProfilePictureErrorAction = (payload) => {
	return {
		type: USER_ACTION_TYPES.SET_USER_PROFILE_PICTURE_ERROR,
		payload,
	};
}
export const sendEmailVerificationOTPAction = (payload) => {
	return {
		type: USER_ACTION_TYPES.SEND_EMAIL_VERIFICATION_OTP,
		payload,
	};
}
export const sendEmailVerificationOTPDoneAction = (payload) => {
	return {
		type: USER_ACTION_TYPES.SEND_EMAIL_VERIFICATION_OTP_DONE,
		payload,
	};
}
export const sendEmailVerificationOTPErrorAction = (payload) => {
	return {
		type: USER_ACTION_TYPES.SEND_EMAIL_VERIFICATION_OTP_ERROR,
		payload,
	};
}
export const addUnverifiedAccountDataFromAccessTokenAction = (payload) => {
	return {
		type: USER_ACTION_TYPES.ADD_UNVERIFIED_ACCOUNT_DATA_FROM_ACCESS_TOKEN,
		payload,
	};
}
export const addUnverifiedAccountDataFromAccessTokenDoneAction = (payload) => {
	return {
		type: USER_ACTION_TYPES.ADD_UNVERIFIED_ACCOUNT_DATA_FROM_ACCESS_TOKEN_DONE,
		payload,
	};
}
export const addUnverifiedAccountDataFromAccessTokenErrorAction = (payload) => {
	return {
		type: USER_ACTION_TYPES.ADD_UNVERIFIED_ACCOUNT_DATA_FROM_ACCESS_TOKEN_ERROR,
		payload,
	};
}

export const fetchProfile = () => async (dispatch) => {
	let response = await fetchApiData(`${API_URL}/auth/user`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			authToken: getLocalStorageItem("ORDER_AUTH_TOKEN"),
		},
	});

	if (response && !response.error) {
		dispatch({
			type: FETCH_PROFILE,
			payload: response.data,
		});
	}
};

export const putUserStatusForOrders = (reqObj) => async (dispatch) => {
	const response = await fetchApiData(`${API_URL}/auth/user`, {
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
			authToken: getLocalStorageItem("ORDER_AUTH_TOKEN"),
		},
		body: JSON.stringify(reqObj),
	});

	if (response && !response.error) {
		dispatch({
			type: SET_SELLER_ORDER_TAKING_STATUS,
			payload: reqObj.isActive,
		})
		displayLog("success", "User status updated successfully")
	} else {
		displayLog("error", response.msg)
	}

};

export const getBidsForInActiveSeller = () => async (dispatch) => {
	try {
		const response = await getInActiveBids();

		if (response && !response.error) {
			dispatch({
				type: SET_BIDS_FOR_INACTIVE_SELLER,
				payload: response.data,
			})

		} else {
			displayLog("error", response.msg)
		}

	} catch (err) {
		displayLog("error", "Something went wrong")
	}

};


export default {
	USER_ACTION_TYPES,
	getCreditDetailsAction,
	getCreditsDetailsDoneAction,
	getCreditsDetailErrorsAction,
	getDashboardDetailsAction,
	setUserProfileAction,
	setUserProfilePictureDoneAction,
	setUserProfilePictureErrorAction,
	addUnverifiedAccountDataFromAccessTokenAction,
	addUnverifiedAccountDataFromAccessTokenDoneAction,
	addUnverifiedAccountDataFromAccessTokenErrorAction,
}